import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  it: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.horses": "Cavalli",
      "nav.map": "Mappa Eventi",
      "nav.auctions": "Aste",
      "nav.certificates": "Certificati",
      "nav.sponsors": "Sponsor",
      "nav.subscription": "Abbonamento",
      
      // Hero
      "hero.title": "Investi nel Futuro Equestre",
      "hero.subtitle": "Piattaforma AI per investimenti equestri in Italia e Svizzera",
      "hero.cta": "Esplora Cavalli",
      
      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.totalHorses": "Cavalli Totali",
      "dashboard.avgRoi": "ROI Medio",
      "dashboard.activeAuctions": "Aste Attive",
      "dashboard.marketTrend": "Trend Mercato",
      "dashboard.myHorses": "I Miei Cavalli",
      "dashboard.myAuctions": "Le Mie Aste",
      "dashboard.activePlan": "Piano Attivo",
      "dashboard.welcome": "Benvenuto",
      "dashboard.manageHorses": "Gestisci i Miei Cavalli",
      "dashboard.manageHorsesDesc": "Aggiungi, modifica o rimuovi cavalli",
      "dashboard.manageAuctions": "Gestisci le Mie Aste",
      "dashboard.manageAuctionsDesc": "Crea nuove aste o gestisci quelle attive",
      "dashboard.recentHorses": "I Miei Cavalli Recenti",
      
      // Horses
      "horses.title": "Catalogo Cavalli",
      "horses.filter.region": "Regione",
      "horses.filter.country": "Paese",
      "horses.filter.all": "Tutti",
      "horses.filter.allRegions": "Tutte le Regioni",
      "horses.age": "Età",
      "horses.years": "anni",
      "horses.breed": "Razza",
      "horses.price": "Prezzo",
      "horses.roi": "ROI Stimato",
      "horses.viewDetails": "Dettagli",
      "horses.analyzeRoi": "Analisi AI",
      "horses.pedigree": "Pedigree",
      "horses.performance": "Performance",
      "horses.competitions": "Competizioni",
      "horses.wins": "Vittorie",
      "horses.places": "Piazzamenti",
      "horses.ranking": "Ranking FISE",
      "horses.anafi": "Statistiche ANAFI",
      "horses.fertility": "Indice Fertilità",
      "horses.geneticScore": "Score Genetico",
      "horses.addHorse": "Aggiungi Cavalli",
      "horses.manualEntry": "Inserimento Manuale",
      "horses.uploadFile": "Upload CSV/JSON",
      "horses.csvFormat": "Formato CSV: name, breed, age, region, country, price_eur, fise_id",
      "horses.notFound": "Cavallo non trovato",
      "horses.featured": "Cavalli in Evidenza",
      "horses.viewAll": "Vedi tutti",
      "horses.regions": "Regioni Coperte",
      "horses.father": "Padre",
      "horses.mother": "Madre",
      "horses.lineage": "Linea",
      
      // Map
      "map.title": "Mappa Eventi FISE/FEI",
      "map.events": "Eventi",
      "map.filter.type": "Tipo Evento",
      "map.all": "Tutti",
      
      // Auctions
      "auctions.title": "Aste Marketplace",
      "auctions.subtitle": "Focus: Verona Fiere",
      "auctions.currentBid": "Offerta Attuale",
      "auctions.startPrice": "Prezzo Base",
      "auctions.commission": "Commissione",
      "auctions.placeBid": "Fai Offerta",
      "auctions.endDate": "Scadenza",
      "auctions.minIncrement": "Incremento Minimo",
      "auctions.yourName": "Il tuo nome",
      "auctions.bidderName": "Nome offerente",
      "auctions.active": "Attiva",
      "auctions.lastBids": "Ultime offerte",
      "auctions.bidError": "L'offerta deve essere maggiore di",
      "auctions.enterName": "Inserisci il tuo nome",
      
      // Certificates
      "certificates.title": "Certificati Sanitari UE",
      "certificates.subtitle": "Certificati sanitari UE con verifica blockchain SHA-256",
      "certificates.blockchain": "Verifica Blockchain",
      "certificates.scanQr": "Scansiona QR",
      "certificates.issueDate": "Data Emissione",
      "certificates.expiryDate": "Scadenza",
      "certificates.authority": "Autorità",
      "certificates.generate": "Genera Certificato",
      "certificates.verify": "Verifica",
      "certificates.issued": "Certificati Emessi",
      "certificates.valid": "Valido",
      "certificates.expired": "Scaduto",
      "certificates.validCert": "Certificato Valido",
      "certificates.invalidCert": "Non Valido",
      "certificates.notFound": "Certificato non trovato",
      "certificates.selectHorse": "Seleziona cavallo",
      "certificates.certType": "Tipo Certificato",
      "certificates.horse": "Cavallo",
      "certificates.hashPlaceholder": "Inserisci hash o primi 12 caratteri",
      "certificates.types.health": "Sanitario UE",
      "certificates.types.export": "Export IT/CH",
      "certificates.types.competition": "Competizione FISE",
      
      // VAT
      "vat.title": "Calcolo IVA IT/CH",
      "vat.from": "Da",
      "vat.to": "A",
      "vat.amount": "Importo",
      "vat.calculate": "Calcola",
      "vat.result": "Risultato",
      "vat.importDuty": "Dazio Import",
      "vat.total": "Totale",
      "vat.vatRate": "Aliquota IVA",
      "vat.dutyAlert": "Attenzione: dazio doganale applicabile",
      
      // Sponsors
      "sponsors.title": "Sponsor Cross-Border",
      "sponsors.subtitle": "Matching sponsor IT/CH con alert dazi import",
      "sponsors.match": "Abbina Sponsor",
      "sponsors.matchScore": "Compatibilità",
      "sponsors.crossBorder": "Cross-Border",
      "sponsors.all": "Tutti gli Sponsor",
      "sponsors.findSponsor": "Cerca Sponsor per i Tuoi Cavalli",
      "sponsors.myRequests": "Le Mie Richieste",
      "sponsors.selectHorse": "Seleziona cavallo per abbinamento",
      "sponsors.loginRequired": "Accedi per cercare sponsor",
      "sponsors.noHorses": "Non hai ancora cavalli. Aggiungine uno per cercare sponsor.",
      "sponsors.addHorse": "Aggiungi Cavallo",
      "sponsors.seekingSponsor": "In cerca di sponsor",
      "sponsors.sendRequest": "Invia Richiesta",
      "sponsors.messagePlaceholder": "Messaggio per lo sponsor (opzionale)",
      "sponsors.types.feed": "Mangimi",
      "sponsors.types.equipment": "Attrezzature",
      "sponsors.types.transport": "Trasporto",
      "sponsors.types.veterinary": "Veterinario",
      "sponsors.types.training": "Allenamento",
      
      // Subscription
      "subscription.title": "Piani Abbonamento",
      "subscription.subtitle": "Scegli il piano più adatto alle tue esigenze",
      "subscription.free": "Free",
      "subscription.premium": "Premium",
      "subscription.professional": "Professional",
      "subscription.monthly": "/mese",
      "subscription.features": "Funzionalità",
      "subscription.subscribe": "Abbonati",
      "subscription.current": "Piano Attuale",
      "subscription.recommended": "Consigliato",
      "subscription.features.catalog": "Accesso catalogo cavalli",
      "subscription.features.basicMap": "Mappa eventi base",
      "subscription.features.limitedAnalysis": "5 analisi ROI/mese",
      "subscription.features.emailNotif": "Notifiche email",
      "subscription.features.allFree": "Tutto Free +",
      "subscription.features.unlimitedAI": "Analisi AI illimitate",
      "subscription.features.sponsorMatch": "Matching sponsor",
      "subscription.features.blockchain": "Certificati blockchain",
      "subscription.features.dutyAlert": "Alert dazi import",
      "subscription.features.prioritySupport": "Supporto prioritario",
      "subscription.features.allPremium": "Tutto Premium +",
      "subscription.features.apiAccess": "API accesso dati",
      "subscription.features.whiteLabel": "White-label reports",
      "subscription.features.consulting": "Consulenza dedicata",
      "subscription.features.privateAuctions": "Gestione aste private",
      "subscription.features.accountManager": "Account manager",
      
      // Auth
      "auth.login": "Accedi",
      "auth.logout": "Esci",
      "auth.register": "Registrati",
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.confirmPassword": "Conferma Password",
      "auth.loginTitle": "Accedi",
      "auth.loginSubtitle": "Accedi al tuo account EquiInvest AI",
      "auth.registerTitle": "Registrati",
      "auth.registerSubtitle": "Crea il tuo account per vendere all'asta",
      "auth.noAccount": "Non hai un account?",
      "auth.hasAccount": "Hai già un account?",
      "auth.loggingIn": "Accesso in corso...",
      "auth.registering": "Registrazione in corso...",
      "auth.createAccount": "Crea Account",
      "auth.accountType": "Tipo Account",
      "auth.name": "Nome/Ragione Sociale",
      "auth.companyName": "Nome Azienda",
      "auth.phone": "Telefono",
      "auth.country": "Paese",
      "auth.region": "Regione",
      "auth.vatNumber": "Partita IVA",
      "auth.types.scuderia": "Scuderia",
      "auth.types.scuderiaDesc": "Gestisci cavalli e aste",
      "auth.types.rivenditore": "Rivenditore",
      "auth.types.rivenditoreDesc": "Vendi cavalli",
      "auth.types.sponsor": "Sponsor",
      "auth.types.sponsorDesc": "Sponsorizza cavalli",
      "auth.types.privato": "Privato",
      "auth.types.privatoDesc": "Acquista cavalli",
      "auth.passwordMismatch": "Le password non corrispondono",
      "auth.passwordTooShort": "La password deve avere almeno 6 caratteri",
      
      // Payment
      "payment.success": "Pagamento Completato!",
      "payment.successMessage": "Grazie per il tuo abbonamento. Il tuo account è stato aggiornato.",
      "payment.processing": "Pagamento in Elaborazione",
      "payment.processingMessage": "Il pagamento è in fase di elaborazione. Riceverai una conferma via email.",
      "payment.backHome": "Torna alla Home",
      "payment.backSubscription": "Torna agli Abbonamenti",
      "payment.verifying": "Verifica pagamento in corso...",
      
      // Notifications
      "notifications.title": "Notifiche",
      "notifications.none": "Nessuna notifica",
      "notifications.newMatch": "Nuovo Match",
      "notifications.newAuction": "Nuova Asta",
      "notifications.bidUpdate": "Aggiornamento Offerta",
      
      // Common
      "common.loading": "Caricamento...",
      "common.error": "Errore",
      "common.success": "Successo",
      "common.save": "Salva",
      "common.cancel": "Annulla",
      "common.delete": "Elimina",
      "common.edit": "Modifica",
      "common.add": "Aggiungi",
      "common.upload": "Carica",
      "common.download": "Scarica",
      "common.italy": "Italia",
      "common.switzerland": "Svizzera",
      "common.all": "Tutti",
      "common.regions.ticino": "Ticino",
      "common.regions.lombardia": "Lombardia",
      "common.regions.toscana": "Toscana",
      "common.regions.piemonte": "Piemonte",
      
      // Navigation - Shops
      "nav.shops": "Negozi",
      
      // Shops
      "shops.title": "Negozi Equestri",
      "shops.all": "Tutti",
      "shops.italy": "Italia",
      "shops.switzerland": "Svizzera",
      "shops.category": "Categoria",
      "shops.categories.all": "Tutte",
      "shops.categories.selleria": "Selleria",
      "shops.categories.mangimi": "Mangimi",
      "shops.categories.veterinario": "Veterinario",
      "shops.categories.maniscalco": "Maniscalco",
      "shops.categories.trasporto": "Trasporto",
      "shops.categories.abbigliamento": "Abbigliamento",
      "shops.categories.attrezzature": "Attrezzature",
      "shops.categories.altro": "Altro",
      "shops.addShop": "Aggiungi Negozio",
      "shops.registerShop": "Registra il tuo negozio",
      "shops.loginToAdd": "Accedi per aggiungere",
      "shops.myShops": "I Miei Negozi",
      "shops.manageShops": "Gestisci Negozi",
      "shops.manageShopsDesc": "I tuoi punti vendita",
      "shops.noShops": "Nessun Negozio",
      "shops.noShopsDesc": "Aggiungi il tuo primo negozio per farlo apparire sulla mappa",
      "shops.shopName": "Nome Negozio",
      "shops.description": "Descrizione",
      "shops.address": "Indirizzo",
      "shops.city": "Città",
      "shops.phone": "Telefono",
      "shops.email": "Email",
      "shops.website": "Sito Web",
      "shops.openingHours": "Orari Apertura",
      "shops.latitude": "Latitudine",
      "shops.longitude": "Longitudine",
      "shops.editShop": "Modifica Negozio",
      "shops.deleteShop": "Elimina Negozio",
      "shops.shopAdded": "Negozio aggiunto con successo!",
      "shops.shopUpdated": "Negozio aggiornato con successo!",
      "shops.shopDeleted": "Negozio eliminato con successo!",
      "shops.confirmDelete": "Sei sicuro di voler eliminare questo negozio?",
      
      // Dashboard - Shops
      "dashboard.myShops": "I Miei Negozi",
      "dashboard.manageShops": "Gestisci Negozi",
      "dashboard.manageShopsDesc": "I tuoi punti vendita",
    }
  },
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.horses": "Horses",
      "nav.map": "Events Map",
      "nav.auctions": "Auctions",
      "nav.certificates": "Certificates",
      "nav.sponsors": "Sponsors",
      "nav.subscription": "Subscription",
      
      // Hero
      "hero.title": "Invest in the Equestrian Future",
      "hero.subtitle": "AI Platform for Horse Investments in Italy and Switzerland",
      "hero.cta": "Explore Horses",
      
      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.totalHorses": "Total Horses",
      "dashboard.avgRoi": "Average ROI",
      "dashboard.activeAuctions": "Active Auctions",
      "dashboard.marketTrend": "Market Trend",
      "dashboard.myHorses": "My Horses",
      "dashboard.myAuctions": "My Auctions",
      "dashboard.activePlan": "Active Plan",
      "dashboard.welcome": "Welcome",
      "dashboard.manageHorses": "Manage My Horses",
      "dashboard.manageHorsesDesc": "Add, edit or remove horses",
      "dashboard.manageAuctions": "Manage My Auctions",
      "dashboard.manageAuctionsDesc": "Create new auctions or manage active ones",
      "dashboard.recentHorses": "My Recent Horses",
      
      // Horses
      "horses.title": "Horse Catalog",
      "horses.filter.region": "Region",
      "horses.filter.country": "Country",
      "horses.filter.all": "All",
      "horses.filter.allRegions": "All Regions",
      "horses.age": "Age",
      "horses.years": "years",
      "horses.breed": "Breed",
      "horses.price": "Price",
      "horses.roi": "Estimated ROI",
      "horses.viewDetails": "Details",
      "horses.analyzeRoi": "AI Analysis",
      "horses.pedigree": "Pedigree",
      "horses.performance": "Performance",
      "horses.competitions": "Competitions",
      "horses.wins": "Wins",
      "horses.places": "Places",
      "horses.ranking": "FISE Ranking",
      "horses.anafi": "ANAFI Stats",
      "horses.fertility": "Fertility Index",
      "horses.geneticScore": "Genetic Score",
      "horses.addHorse": "Add Horses",
      "horses.manualEntry": "Manual Entry",
      "horses.uploadFile": "Upload CSV/JSON",
      "horses.csvFormat": "CSV Format: name, breed, age, region, country, price_eur, fise_id",
      "horses.notFound": "Horse not found",
      "horses.featured": "Featured Horses",
      "horses.viewAll": "View all",
      "horses.regions": "Covered Regions",
      "horses.father": "Sire",
      "horses.mother": "Dam",
      "horses.lineage": "Lineage",
      
      // Map
      "map.title": "FISE/FEI Events Map",
      "map.events": "Events",
      "map.filter.type": "Event Type",
      "map.all": "All",
      
      // Auctions
      "auctions.title": "Auctions Marketplace",
      "auctions.subtitle": "Focus: Verona Fiere",
      "auctions.currentBid": "Current Bid",
      "auctions.startPrice": "Start Price",
      "auctions.commission": "Commission",
      "auctions.placeBid": "Place Bid",
      "auctions.endDate": "End Date",
      "auctions.minIncrement": "Min Increment",
      "auctions.yourName": "Your name",
      "auctions.bidderName": "Bidder name",
      "auctions.active": "Active",
      "auctions.lastBids": "Last bids",
      "auctions.bidError": "Bid must be greater than",
      "auctions.enterName": "Enter your name",
      
      // Certificates
      "certificates.title": "EU Health Certificates",
      "certificates.subtitle": "EU health certificates with SHA-256 blockchain verification",
      "certificates.blockchain": "Blockchain Verification",
      "certificates.scanQr": "Scan QR",
      "certificates.issueDate": "Issue Date",
      "certificates.expiryDate": "Expiry Date",
      "certificates.authority": "Authority",
      "certificates.generate": "Generate Certificate",
      "certificates.verify": "Verify",
      "certificates.issued": "Issued Certificates",
      "certificates.valid": "Valid",
      "certificates.expired": "Expired",
      "certificates.validCert": "Valid Certificate",
      "certificates.invalidCert": "Invalid",
      "certificates.notFound": "Certificate not found",
      "certificates.selectHorse": "Select horse",
      "certificates.certType": "Certificate Type",
      "certificates.horse": "Horse",
      "certificates.hashPlaceholder": "Enter hash or first 12 characters",
      "certificates.types.health": "EU Health",
      "certificates.types.export": "Export IT/CH",
      "certificates.types.competition": "FISE Competition",
      
      // VAT
      "vat.title": "VAT Calculator IT/CH",
      "vat.from": "From",
      "vat.to": "To",
      "vat.amount": "Amount",
      "vat.calculate": "Calculate",
      "vat.result": "Result",
      "vat.importDuty": "Import Duty",
      "vat.total": "Total",
      "vat.vatRate": "VAT Rate",
      "vat.dutyAlert": "Warning: customs duty applicable",
      
      // Sponsors
      "sponsors.title": "Cross-Border Sponsors",
      "sponsors.subtitle": "IT/CH sponsor matching with import duty alerts",
      "sponsors.match": "Match Sponsor",
      "sponsors.matchScore": "Match Score",
      "sponsors.crossBorder": "Cross-Border",
      "sponsors.all": "All Sponsors",
      "sponsors.findSponsor": "Find Sponsors for Your Horses",
      "sponsors.myRequests": "My Requests",
      "sponsors.selectHorse": "Select horse for matching",
      "sponsors.loginRequired": "Login to find sponsors",
      "sponsors.noHorses": "You don't have any horses yet. Add one to find sponsors.",
      "sponsors.addHorse": "Add Horse",
      "sponsors.seekingSponsor": "Seeking sponsor",
      "sponsors.sendRequest": "Send Request",
      "sponsors.messagePlaceholder": "Message to sponsor (optional)",
      "sponsors.types.feed": "Feed",
      "sponsors.types.equipment": "Equipment",
      "sponsors.types.transport": "Transport",
      "sponsors.types.veterinary": "Veterinary",
      "sponsors.types.training": "Training",
      
      // Subscription
      "subscription.title": "Subscription Plans",
      "subscription.subtitle": "Choose the plan that suits your needs",
      "subscription.free": "Free",
      "subscription.premium": "Premium",
      "subscription.professional": "Professional",
      "subscription.monthly": "/month",
      "subscription.features": "Features",
      "subscription.subscribe": "Subscribe",
      "subscription.current": "Current Plan",
      "subscription.recommended": "Recommended",
      "subscription.features.catalog": "Horse catalog access",
      "subscription.features.basicMap": "Basic events map",
      "subscription.features.limitedAnalysis": "5 ROI analyses/month",
      "subscription.features.emailNotif": "Email notifications",
      "subscription.features.allFree": "All Free +",
      "subscription.features.unlimitedAI": "Unlimited AI analysis",
      "subscription.features.sponsorMatch": "Sponsor matching",
      "subscription.features.blockchain": "Blockchain certificates",
      "subscription.features.dutyAlert": "Import duty alerts",
      "subscription.features.prioritySupport": "Priority support",
      "subscription.features.allPremium": "All Premium +",
      "subscription.features.apiAccess": "API data access",
      "subscription.features.whiteLabel": "White-label reports",
      "subscription.features.consulting": "Dedicated consulting",
      "subscription.features.privateAuctions": "Private auctions management",
      "subscription.features.accountManager": "Account manager",
      
      // Auth
      "auth.login": "Login",
      "auth.logout": "Logout",
      "auth.register": "Register",
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.confirmPassword": "Confirm Password",
      "auth.loginTitle": "Login",
      "auth.loginSubtitle": "Login to your EquiInvest AI account",
      "auth.registerTitle": "Register",
      "auth.registerSubtitle": "Create your account to sell at auction",
      "auth.noAccount": "Don't have an account?",
      "auth.hasAccount": "Already have an account?",
      "auth.loggingIn": "Logging in...",
      "auth.registering": "Registering...",
      "auth.createAccount": "Create Account",
      "auth.accountType": "Account Type",
      "auth.name": "Name/Company Name",
      "auth.companyName": "Company Name",
      "auth.phone": "Phone",
      "auth.country": "Country",
      "auth.region": "Region",
      "auth.vatNumber": "VAT Number",
      "auth.types.scuderia": "Stable",
      "auth.types.scuderiaDesc": "Manage horses and auctions",
      "auth.types.rivenditore": "Dealer",
      "auth.types.rivenditoreDesc": "Sell horses",
      "auth.types.sponsor": "Sponsor",
      "auth.types.sponsorDesc": "Sponsor horses",
      "auth.types.privato": "Private",
      "auth.types.privatoDesc": "Buy horses",
      "auth.passwordMismatch": "Passwords do not match",
      "auth.passwordTooShort": "Password must be at least 6 characters",
      
      // Payment
      "payment.success": "Payment Complete!",
      "payment.successMessage": "Thank you for your subscription. Your account has been updated.",
      "payment.processing": "Payment Processing",
      "payment.processingMessage": "Payment is being processed. You will receive a confirmation email.",
      "payment.backHome": "Back to Home",
      "payment.backSubscription": "Back to Subscriptions",
      "payment.verifying": "Verifying payment...",
      
      // Notifications
      "notifications.title": "Notifications",
      "notifications.none": "No notifications",
      "notifications.newMatch": "New Match",
      "notifications.newAuction": "New Auction",
      "notifications.bidUpdate": "Bid Update",
      
      // Common
      "common.loading": "Loading...",
      "common.error": "Error",
      "common.success": "Success",
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.add": "Add",
      "common.upload": "Upload",
      "common.download": "Download",
      "common.italy": "Italy",
      "common.switzerland": "Switzerland",
      "common.all": "All",
      "common.regions.ticino": "Ticino",
      "common.regions.lombardia": "Lombardy",
      "common.regions.toscana": "Tuscany",
      "common.regions.piemonte": "Piedmont",
      
      // Navigation - Shops
      "nav.shops": "Shops",
      
      // Shops
      "shops.title": "Equestrian Shops",
      "shops.all": "All",
      "shops.italy": "Italy",
      "shops.switzerland": "Switzerland",
      "shops.category": "Category",
      "shops.categories.all": "All",
      "shops.categories.selleria": "Saddlery",
      "shops.categories.mangimi": "Feed",
      "shops.categories.veterinario": "Veterinary",
      "shops.categories.maniscalco": "Farrier",
      "shops.categories.trasporto": "Transport",
      "shops.categories.abbigliamento": "Clothing",
      "shops.categories.attrezzature": "Equipment",
      "shops.categories.altro": "Other",
      "shops.addShop": "Add Shop",
      "shops.registerShop": "Register your shop",
      "shops.loginToAdd": "Login to add",
      "shops.myShops": "My Shops",
      "shops.manageShops": "Manage Shops",
      "shops.manageShopsDesc": "Your retail locations",
      "shops.noShops": "No Shops",
      "shops.noShopsDesc": "Add your first shop to display it on the map",
      "shops.shopName": "Shop Name",
      "shops.description": "Description",
      "shops.address": "Address",
      "shops.city": "City",
      "shops.phone": "Phone",
      "shops.email": "Email",
      "shops.website": "Website",
      "shops.openingHours": "Opening Hours",
      "shops.latitude": "Latitude",
      "shops.longitude": "Longitude",
      "shops.editShop": "Edit Shop",
      "shops.deleteShop": "Delete Shop",
      "shops.shopAdded": "Shop added successfully!",
      "shops.shopUpdated": "Shop updated successfully!",
      "shops.shopDeleted": "Shop deleted successfully!",
      "shops.confirmDelete": "Are you sure you want to delete this shop?",
      
      // Dashboard - Shops
      "dashboard.myShops": "My Shops",
      "dashboard.manageShops": "Manage Shops",
      "dashboard.manageShopsDesc": "Your retail locations",
    }
  },
  de: {
    translation: {
      // Navigation
      "nav.home": "Startseite",
      "nav.horses": "Pferde",
      "nav.map": "Veranstaltungskarte",
      "nav.auctions": "Auktionen",
      "nav.certificates": "Zertifikate",
      "nav.sponsors": "Sponsoren",
      "nav.subscription": "Abonnement",
      
      // Hero
      "hero.title": "Investieren Sie in die Reiterzukunft",
      "hero.subtitle": "KI-Plattform für Pferdeinvestitionen in Italien und der Schweiz",
      "hero.cta": "Pferde Entdecken",
      
      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.totalHorses": "Gesamte Pferde",
      "dashboard.avgRoi": "Durchschn. ROI",
      "dashboard.activeAuctions": "Aktive Auktionen",
      "dashboard.marketTrend": "Markttrend",
      "dashboard.myHorses": "Meine Pferde",
      "dashboard.myAuctions": "Meine Auktionen",
      "dashboard.activePlan": "Aktiver Plan",
      "dashboard.welcome": "Willkommen",
      "dashboard.manageHorses": "Meine Pferde verwalten",
      "dashboard.manageHorsesDesc": "Pferde hinzufügen, bearbeiten oder entfernen",
      "dashboard.manageAuctions": "Meine Auktionen verwalten",
      "dashboard.manageAuctionsDesc": "Neue Auktionen erstellen oder aktive verwalten",
      "dashboard.recentHorses": "Meine neuesten Pferde",
      
      // Horses
      "horses.title": "Pferdekatalog",
      "horses.filter.region": "Region",
      "horses.filter.country": "Land",
      "horses.filter.all": "Alle",
      "horses.filter.allRegions": "Alle Regionen",
      "horses.age": "Alter",
      "horses.years": "Jahre",
      "horses.breed": "Rasse",
      "horses.price": "Preis",
      "horses.roi": "Geschätzter ROI",
      "horses.viewDetails": "Details",
      "horses.analyzeRoi": "KI-Analyse",
      "horses.pedigree": "Abstammung",
      "horses.performance": "Leistung",
      "horses.competitions": "Wettbewerbe",
      "horses.wins": "Siege",
      "horses.places": "Platzierungen",
      "horses.ranking": "FISE Ranking",
      "horses.anafi": "ANAFI Statistiken",
      "horses.fertility": "Fruchtbarkeitsindex",
      "horses.geneticScore": "Genetischer Score",
      "horses.addHorse": "Pferde hinzufügen",
      "horses.manualEntry": "Manuelle Eingabe",
      "horses.uploadFile": "CSV/JSON hochladen",
      "horses.csvFormat": "CSV-Format: name, breed, age, region, country, price_eur, fise_id",
      "horses.notFound": "Pferd nicht gefunden",
      "horses.featured": "Ausgewählte Pferde",
      "horses.viewAll": "Alle anzeigen",
      "horses.regions": "Abgedeckte Regionen",
      "horses.father": "Vater",
      "horses.mother": "Mutter",
      "horses.lineage": "Linie",
      
      // Map
      "map.title": "FISE/FEI Veranstaltungskarte",
      "map.events": "Veranstaltungen",
      "map.filter.type": "Veranstaltungstyp",
      "map.all": "Alle",
      
      // Auctions
      "auctions.title": "Auktions-Marktplatz",
      "auctions.subtitle": "Fokus: Verona Fiere",
      "auctions.currentBid": "Aktuelles Gebot",
      "auctions.startPrice": "Startpreis",
      "auctions.commission": "Provision",
      "auctions.placeBid": "Gebot abgeben",
      "auctions.endDate": "Enddatum",
      "auctions.minIncrement": "Min. Erhöhung",
      "auctions.yourName": "Ihr Name",
      "auctions.bidderName": "Name des Bieters",
      "auctions.active": "Aktiv",
      "auctions.lastBids": "Letzte Gebote",
      "auctions.bidError": "Gebot muss höher sein als",
      "auctions.enterName": "Geben Sie Ihren Namen ein",
      
      // Certificates
      "certificates.title": "EU-Gesundheitszertifikate",
      "certificates.subtitle": "EU-Gesundheitszertifikate mit SHA-256 Blockchain-Verifizierung",
      "certificates.blockchain": "Blockchain-Verifizierung",
      "certificates.scanQr": "QR scannen",
      "certificates.issueDate": "Ausstellungsdatum",
      "certificates.expiryDate": "Ablaufdatum",
      "certificates.authority": "Behörde",
      "certificates.generate": "Zertifikat erstellen",
      "certificates.verify": "Verifizieren",
      "certificates.issued": "Ausgestellte Zertifikate",
      "certificates.valid": "Gültig",
      "certificates.expired": "Abgelaufen",
      "certificates.validCert": "Gültiges Zertifikat",
      "certificates.invalidCert": "Ungültig",
      "certificates.notFound": "Zertifikat nicht gefunden",
      "certificates.selectHorse": "Pferd auswählen",
      "certificates.certType": "Zertifikatstyp",
      "certificates.horse": "Pferd",
      "certificates.hashPlaceholder": "Hash oder erste 12 Zeichen eingeben",
      "certificates.types.health": "EU-Gesundheit",
      "certificates.types.export": "Export IT/CH",
      "certificates.types.competition": "FISE Wettbewerb",
      
      // VAT
      "vat.title": "MwSt-Rechner IT/CH",
      "vat.from": "Von",
      "vat.to": "Nach",
      "vat.amount": "Betrag",
      "vat.calculate": "Berechnen",
      "vat.result": "Ergebnis",
      "vat.importDuty": "Importzoll",
      "vat.total": "Gesamt",
      "vat.vatRate": "MwSt-Satz",
      "vat.dutyAlert": "Achtung: Zollgebühr anwendbar",
      
      // Sponsors
      "sponsors.title": "Grenzüberschreitende Sponsoren",
      "sponsors.subtitle": "IT/CH Sponsor-Matching mit Importzoll-Warnungen",
      "sponsors.match": "Sponsor zuordnen",
      "sponsors.matchScore": "Übereinstimmung",
      "sponsors.crossBorder": "Grenzüberschreitend",
      "sponsors.all": "Alle Sponsoren",
      "sponsors.findSponsor": "Sponsoren für Ihre Pferde finden",
      "sponsors.myRequests": "Meine Anfragen",
      "sponsors.selectHorse": "Pferd für Zuordnung auswählen",
      "sponsors.loginRequired": "Anmelden um Sponsoren zu finden",
      "sponsors.noHorses": "Sie haben noch keine Pferde. Fügen Sie eines hinzu um Sponsoren zu finden.",
      "sponsors.addHorse": "Pferd hinzufügen",
      "sponsors.seekingSponsor": "Sucht Sponsor",
      "sponsors.sendRequest": "Anfrage senden",
      "sponsors.messagePlaceholder": "Nachricht an Sponsor (optional)",
      "sponsors.types.feed": "Futter",
      "sponsors.types.equipment": "Ausrüstung",
      "sponsors.types.transport": "Transport",
      "sponsors.types.veterinary": "Tierarzt",
      "sponsors.types.training": "Training",
      
      // Subscription
      "subscription.title": "Abonnementpläne",
      "subscription.subtitle": "Wählen Sie den Plan, der Ihren Bedürfnissen entspricht",
      "subscription.free": "Kostenlos",
      "subscription.premium": "Premium",
      "subscription.professional": "Professional",
      "subscription.monthly": "/Monat",
      "subscription.features": "Funktionen",
      "subscription.subscribe": "Abonnieren",
      "subscription.current": "Aktueller Plan",
      "subscription.recommended": "Empfohlen",
      "subscription.features.catalog": "Zugang zum Pferdekatalog",
      "subscription.features.basicMap": "Basis-Veranstaltungskarte",
      "subscription.features.limitedAnalysis": "5 ROI-Analysen/Monat",
      "subscription.features.emailNotif": "E-Mail-Benachrichtigungen",
      "subscription.features.allFree": "Alles Kostenlos +",
      "subscription.features.unlimitedAI": "Unbegrenzte KI-Analyse",
      "subscription.features.sponsorMatch": "Sponsor-Matching",
      "subscription.features.blockchain": "Blockchain-Zertifikate",
      "subscription.features.dutyAlert": "Importzoll-Warnungen",
      "subscription.features.prioritySupport": "Prioritäts-Support",
      "subscription.features.allPremium": "Alles Premium +",
      "subscription.features.apiAccess": "API-Datenzugriff",
      "subscription.features.whiteLabel": "White-Label-Berichte",
      "subscription.features.consulting": "Dedizierte Beratung",
      "subscription.features.privateAuctions": "Private Auktionsverwaltung",
      "subscription.features.accountManager": "Account Manager",
      
      // Auth
      "auth.login": "Anmelden",
      "auth.logout": "Abmelden",
      "auth.register": "Registrieren",
      "auth.email": "E-Mail",
      "auth.password": "Passwort",
      "auth.confirmPassword": "Passwort bestätigen",
      "auth.loginTitle": "Anmelden",
      "auth.loginSubtitle": "Bei Ihrem EquiInvest AI Konto anmelden",
      "auth.registerTitle": "Registrieren",
      "auth.registerSubtitle": "Erstellen Sie Ihr Konto für Auktionen",
      "auth.noAccount": "Kein Konto?",
      "auth.hasAccount": "Haben Sie bereits ein Konto?",
      "auth.loggingIn": "Anmeldung...",
      "auth.registering": "Registrierung...",
      "auth.createAccount": "Konto erstellen",
      "auth.accountType": "Kontotyp",
      "auth.name": "Name/Firmenname",
      "auth.companyName": "Firmenname",
      "auth.phone": "Telefon",
      "auth.country": "Land",
      "auth.region": "Region",
      "auth.vatNumber": "USt-IdNr.",
      "auth.types.scuderia": "Reitstall",
      "auth.types.scuderiaDesc": "Pferde und Auktionen verwalten",
      "auth.types.rivenditore": "Händler",
      "auth.types.rivenditoreDesc": "Pferde verkaufen",
      "auth.types.sponsor": "Sponsor",
      "auth.types.sponsorDesc": "Pferde sponsern",
      "auth.types.privato": "Privat",
      "auth.types.privatoDesc": "Pferde kaufen",
      "auth.passwordMismatch": "Passwörter stimmen nicht überein",
      "auth.passwordTooShort": "Passwort muss mindestens 6 Zeichen haben",
      
      // Payment
      "payment.success": "Zahlung abgeschlossen!",
      "payment.successMessage": "Vielen Dank für Ihr Abonnement. Ihr Konto wurde aktualisiert.",
      "payment.processing": "Zahlung wird verarbeitet",
      "payment.processingMessage": "Die Zahlung wird verarbeitet. Sie erhalten eine Bestätigungs-E-Mail.",
      "payment.backHome": "Zurück zur Startseite",
      "payment.backSubscription": "Zurück zu Abonnements",
      "payment.verifying": "Zahlung wird überprüft...",
      
      // Notifications
      "notifications.title": "Benachrichtigungen",
      "notifications.none": "Keine Benachrichtigungen",
      "notifications.newMatch": "Neuer Match",
      "notifications.newAuction": "Neue Auktion",
      "notifications.bidUpdate": "Gebots-Update",
      
      // Common
      "common.loading": "Laden...",
      "common.error": "Fehler",
      "common.success": "Erfolg",
      "common.save": "Speichern",
      "common.cancel": "Abbrechen",
      "common.delete": "Löschen",
      "common.edit": "Bearbeiten",
      "common.add": "Hinzufügen",
      "common.upload": "Hochladen",
      "common.download": "Herunterladen",
      "common.italy": "Italien",
      "common.switzerland": "Schweiz",
      "common.all": "Alle",
      "common.regions.ticino": "Tessin",
      "common.regions.lombardia": "Lombardei",
      "common.regions.toscana": "Toskana",
      "common.regions.piemonte": "Piemont",
      
      // Navigation - Shops
      "nav.shops": "Geschäfte",
      
      // Shops
      "shops.title": "Reitsportgeschäfte",
      "shops.all": "Alle",
      "shops.italy": "Italien",
      "shops.switzerland": "Schweiz",
      "shops.category": "Kategorie",
      "shops.categories.all": "Alle",
      "shops.categories.selleria": "Sattlerei",
      "shops.categories.mangimi": "Futter",
      "shops.categories.veterinario": "Tierarzt",
      "shops.categories.maniscalco": "Hufschmied",
      "shops.categories.trasporto": "Transport",
      "shops.categories.abbigliamento": "Bekleidung",
      "shops.categories.attrezzature": "Ausrüstung",
      "shops.categories.altro": "Sonstiges",
      "shops.addShop": "Geschäft hinzufügen",
      "shops.registerShop": "Registrieren Sie Ihr Geschäft",
      "shops.loginToAdd": "Anmelden zum Hinzufügen",
      "shops.myShops": "Meine Geschäfte",
      "shops.manageShops": "Geschäfte verwalten",
      "shops.manageShopsDesc": "Ihre Verkaufsstellen",
      "shops.noShops": "Keine Geschäfte",
      "shops.noShopsDesc": "Fügen Sie Ihr erstes Geschäft hinzu, um es auf der Karte anzuzeigen",
      "shops.shopName": "Geschäftsname",
      "shops.description": "Beschreibung",
      "shops.address": "Adresse",
      "shops.city": "Stadt",
      "shops.phone": "Telefon",
      "shops.email": "E-Mail",
      "shops.website": "Website",
      "shops.openingHours": "Öffnungszeiten",
      "shops.latitude": "Breitengrad",
      "shops.longitude": "Längengrad",
      "shops.editShop": "Geschäft bearbeiten",
      "shops.deleteShop": "Geschäft löschen",
      "shops.shopAdded": "Geschäft erfolgreich hinzugefügt!",
      "shops.shopUpdated": "Geschäft erfolgreich aktualisiert!",
      "shops.shopDeleted": "Geschäft erfolgreich gelöscht!",
      "shops.confirmDelete": "Sind Sie sicher, dass Sie dieses Geschäft löschen möchten?",
      
      // Dashboard - Shops
      "dashboard.myShops": "Meine Geschäfte",
      "dashboard.manageShops": "Geschäfte verwalten",
      "dashboard.manageShopsDesc": "Ihre Verkaufsstellen",
    }
  },
  nl: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.horses": "Paarden",
      "nav.map": "Evenementenkaart",
      "nav.auctions": "Veilingen",
      "nav.certificates": "Certificaten",
      "nav.sponsors": "Sponsors",
      "nav.subscription": "Abonnement",
      
      // Hero
      "hero.title": "Investeer in de Paardensport",
      "hero.subtitle": "AI-platform voor paardeninvesteringen in Italië en Zwitserland",
      "hero.cta": "Ontdek Paarden",
      
      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.totalHorses": "Totaal Paarden",
      "dashboard.avgRoi": "Gemiddelde ROI",
      "dashboard.activeAuctions": "Actieve Veilingen",
      "dashboard.marketTrend": "Markttrend",
      "dashboard.myHorses": "Mijn Paarden",
      "dashboard.myAuctions": "Mijn Veilingen",
      "dashboard.activePlan": "Actief Plan",
      "dashboard.welcome": "Welkom",
      "dashboard.manageHorses": "Beheer Mijn Paarden",
      "dashboard.manageHorsesDesc": "Voeg paarden toe, bewerk of verwijder ze",
      "dashboard.manageAuctions": "Beheer Mijn Veilingen",
      "dashboard.manageAuctionsDesc": "Maak nieuwe veilingen of beheer actieve",
      "dashboard.recentHorses": "Mijn Recente Paarden",
      
      // Horses
      "horses.title": "Paardencatalogus",
      "horses.filter.region": "Regio",
      "horses.filter.country": "Land",
      "horses.filter.all": "Alle",
      "horses.filter.allRegions": "Alle Regio's",
      "horses.age": "Leeftijd",
      "horses.years": "jaar",
      "horses.breed": "Ras",
      "horses.price": "Prijs",
      "horses.roi": "Geschatte ROI",
      "horses.viewDetails": "Details",
      "horses.analyzeRoi": "AI Analyse",
      "horses.pedigree": "Stamboom",
      "horses.performance": "Prestaties",
      "horses.competitions": "Wedstrijden",
      "horses.wins": "Overwinningen",
      "horses.places": "Plaatsingen",
      "horses.ranking": "FISE Ranking",
      "horses.anafi": "ANAFI Statistieken",
      "horses.fertility": "Vruchtbaarheidsindex",
      "horses.geneticScore": "Genetische Score",
      "horses.addHorse": "Paarden Toevoegen",
      "horses.manualEntry": "Handmatige Invoer",
      "horses.uploadFile": "CSV/JSON Uploaden",
      "horses.csvFormat": "CSV-formaat: name, breed, age, region, country, price_eur, fise_id",
      "horses.notFound": "Paard niet gevonden",
      "horses.featured": "Uitgelichte Paarden",
      "horses.viewAll": "Bekijk alle",
      "horses.regions": "Gedekte Regio's",
      "horses.father": "Vader",
      "horses.mother": "Moeder",
      "horses.lineage": "Lijn",
      
      // Map
      "map.title": "FISE/FEI Evenementenkaart",
      "map.events": "Evenementen",
      "map.filter.type": "Evenementtype",
      "map.all": "Alle",
      
      // Auctions
      "auctions.title": "Veilingen Marktplaats",
      "auctions.subtitle": "Focus: Verona Fiere",
      "auctions.currentBid": "Huidig Bod",
      "auctions.startPrice": "Startprijs",
      "auctions.commission": "Commissie",
      "auctions.placeBid": "Bied",
      "auctions.endDate": "Einddatum",
      "auctions.minIncrement": "Min. Verhoging",
      "auctions.yourName": "Uw naam",
      "auctions.bidderName": "Naam bieder",
      "auctions.active": "Actief",
      "auctions.lastBids": "Laatste biedingen",
      "auctions.bidError": "Bod moet hoger zijn dan",
      "auctions.enterName": "Voer uw naam in",
      
      // Certificates
      "certificates.title": "EU Gezondheidscertificaten",
      "certificates.subtitle": "EU gezondheidscertificaten met SHA-256 blockchain verificatie",
      "certificates.blockchain": "Blockchain Verificatie",
      "certificates.scanQr": "QR Scannen",
      "certificates.issueDate": "Uitgiftedatum",
      "certificates.expiryDate": "Vervaldatum",
      "certificates.authority": "Autoriteit",
      "certificates.generate": "Certificaat Genereren",
      "certificates.verify": "Verifiëren",
      "certificates.issued": "Uitgegeven Certificaten",
      "certificates.valid": "Geldig",
      "certificates.expired": "Verlopen",
      "certificates.validCert": "Geldig Certificaat",
      "certificates.invalidCert": "Ongeldig",
      "certificates.notFound": "Certificaat niet gevonden",
      "certificates.selectHorse": "Selecteer paard",
      "certificates.certType": "Certificaattype",
      "certificates.horse": "Paard",
      "certificates.hashPlaceholder": "Voer hash of eerste 12 tekens in",
      "certificates.types.health": "EU Gezondheid",
      "certificates.types.export": "Export IT/CH",
      "certificates.types.competition": "FISE Wedstrijd",
      
      // VAT
      "vat.title": "BTW Calculator IT/CH",
      "vat.from": "Van",
      "vat.to": "Naar",
      "vat.amount": "Bedrag",
      "vat.calculate": "Berekenen",
      "vat.result": "Resultaat",
      "vat.importDuty": "Invoerrechten",
      "vat.total": "Totaal",
      "vat.vatRate": "BTW-tarief",
      "vat.dutyAlert": "Let op: douanerecht van toepassing",
      
      // Sponsors
      "sponsors.title": "Grensoverschrijdende Sponsors",
      "sponsors.subtitle": "IT/CH sponsor matching met invoerrechten waarschuwingen",
      "sponsors.match": "Sponsor Koppelen",
      "sponsors.matchScore": "Overeenkomst",
      "sponsors.crossBorder": "Grensoverschrijdend",
      "sponsors.all": "Alle Sponsors",
      "sponsors.findSponsor": "Vind Sponsors voor Uw Paarden",
      "sponsors.myRequests": "Mijn Aanvragen",
      "sponsors.selectHorse": "Selecteer paard voor koppeling",
      "sponsors.loginRequired": "Log in om sponsors te vinden",
      "sponsors.noHorses": "U heeft nog geen paarden. Voeg er een toe om sponsors te vinden.",
      "sponsors.addHorse": "Paard Toevoegen",
      "sponsors.seekingSponsor": "Zoekt sponsor",
      "sponsors.sendRequest": "Aanvraag Verzenden",
      "sponsors.messagePlaceholder": "Bericht aan sponsor (optioneel)",
      "sponsors.types.feed": "Voer",
      "sponsors.types.equipment": "Uitrusting",
      "sponsors.types.transport": "Transport",
      "sponsors.types.veterinary": "Dierenarts",
      "sponsors.types.training": "Training",
      
      // Subscription
      "subscription.title": "Abonnementsplannen",
      "subscription.subtitle": "Kies het plan dat bij uw behoeften past",
      "subscription.free": "Gratis",
      "subscription.premium": "Premium",
      "subscription.professional": "Professional",
      "subscription.monthly": "/maand",
      "subscription.features": "Functies",
      "subscription.subscribe": "Abonneren",
      "subscription.current": "Huidig Plan",
      "subscription.recommended": "Aanbevolen",
      "subscription.features.catalog": "Toegang tot paardencatalogus",
      "subscription.features.basicMap": "Basis evenementenkaart",
      "subscription.features.limitedAnalysis": "5 ROI-analyses/maand",
      "subscription.features.emailNotif": "E-mailmeldingen",
      "subscription.features.allFree": "Alles Gratis +",
      "subscription.features.unlimitedAI": "Onbeperkte AI-analyse",
      "subscription.features.sponsorMatch": "Sponsor matching",
      "subscription.features.blockchain": "Blockchain certificaten",
      "subscription.features.dutyAlert": "Invoerrechten waarschuwingen",
      "subscription.features.prioritySupport": "Prioriteit support",
      "subscription.features.allPremium": "Alles Premium +",
      "subscription.features.apiAccess": "API data toegang",
      "subscription.features.whiteLabel": "White-label rapporten",
      "subscription.features.consulting": "Toegewijd advies",
      "subscription.features.privateAuctions": "Privé veilingbeheer",
      "subscription.features.accountManager": "Account manager",
      
      // Auth
      "auth.login": "Inloggen",
      "auth.logout": "Uitloggen",
      "auth.register": "Registreren",
      "auth.email": "E-mail",
      "auth.password": "Wachtwoord",
      "auth.confirmPassword": "Bevestig Wachtwoord",
      "auth.loginTitle": "Inloggen",
      "auth.loginSubtitle": "Log in op uw EquiInvest AI account",
      "auth.registerTitle": "Registreren",
      "auth.registerSubtitle": "Maak uw account aan om te veilen",
      "auth.noAccount": "Geen account?",
      "auth.hasAccount": "Heeft u al een account?",
      "auth.loggingIn": "Inloggen...",
      "auth.registering": "Registreren...",
      "auth.createAccount": "Account Aanmaken",
      "auth.accountType": "Accounttype",
      "auth.name": "Naam/Bedrijfsnaam",
      "auth.companyName": "Bedrijfsnaam",
      "auth.phone": "Telefoon",
      "auth.country": "Land",
      "auth.region": "Regio",
      "auth.vatNumber": "BTW-nummer",
      "auth.types.scuderia": "Stal",
      "auth.types.scuderiaDesc": "Beheer paarden en veilingen",
      "auth.types.rivenditore": "Handelaar",
      "auth.types.rivenditoreDesc": "Verkoop paarden",
      "auth.types.sponsor": "Sponsor",
      "auth.types.sponsorDesc": "Sponsor paarden",
      "auth.types.privato": "Particulier",
      "auth.types.privatoDesc": "Koop paarden",
      "auth.passwordMismatch": "Wachtwoorden komen niet overeen",
      "auth.passwordTooShort": "Wachtwoord moet minimaal 6 tekens bevatten",
      
      // Payment
      "payment.success": "Betaling Voltooid!",
      "payment.successMessage": "Bedankt voor uw abonnement. Uw account is bijgewerkt.",
      "payment.processing": "Betaling Wordt Verwerkt",
      "payment.processingMessage": "De betaling wordt verwerkt. U ontvangt een bevestigingsmail.",
      "payment.backHome": "Terug naar Home",
      "payment.backSubscription": "Terug naar Abonnementen",
      "payment.verifying": "Betaling verifiëren...",
      
      // Notifications
      "notifications.title": "Meldingen",
      "notifications.none": "Geen meldingen",
      "notifications.newMatch": "Nieuwe Match",
      "notifications.newAuction": "Nieuwe Veiling",
      "notifications.bidUpdate": "Bod Update",
      
      // Common
      "common.loading": "Laden...",
      "common.error": "Fout",
      "common.success": "Succes",
      "common.save": "Opslaan",
      "common.cancel": "Annuleren",
      "common.delete": "Verwijderen",
      "common.edit": "Bewerken",
      "common.add": "Toevoegen",
      "common.upload": "Uploaden",
      "common.download": "Downloaden",
      "common.italy": "Italië",
      "common.switzerland": "Zwitserland",
      "common.all": "Alle",
      "common.regions.ticino": "Ticino",
      "common.regions.lombardia": "Lombardije",
      "common.regions.toscana": "Toscane",
      "common.regions.piemonte": "Piëmont",
      
      // Navigation - Shops
      "nav.shops": "Winkels",
      
      // Shops
      "shops.title": "Paardensportwinkels",
      "shops.all": "Alle",
      "shops.italy": "Italië",
      "shops.switzerland": "Zwitserland",
      "shops.category": "Categorie",
      "shops.categories.all": "Alle",
      "shops.categories.selleria": "Zadelmakerij",
      "shops.categories.mangimi": "Voer",
      "shops.categories.veterinario": "Dierenarts",
      "shops.categories.maniscalco": "Hoefsmid",
      "shops.categories.trasporto": "Transport",
      "shops.categories.abbigliamento": "Kleding",
      "shops.categories.attrezzature": "Uitrusting",
      "shops.categories.altro": "Overig",
      "shops.addShop": "Winkel toevoegen",
      "shops.registerShop": "Registreer uw winkel",
      "shops.loginToAdd": "Inloggen om toe te voegen",
      "shops.myShops": "Mijn Winkels",
      "shops.manageShops": "Winkels beheren",
      "shops.manageShopsDesc": "Uw verkooppunten",
      "shops.noShops": "Geen Winkels",
      "shops.noShopsDesc": "Voeg uw eerste winkel toe om deze op de kaart te tonen",
      "shops.shopName": "Winkelnaam",
      "shops.description": "Beschrijving",
      "shops.address": "Adres",
      "shops.city": "Stad",
      "shops.phone": "Telefoon",
      "shops.email": "E-mail",
      "shops.website": "Website",
      "shops.openingHours": "Openingstijden",
      "shops.latitude": "Breedtegraad",
      "shops.longitude": "Lengtegraad",
      "shops.editShop": "Winkel bewerken",
      "shops.deleteShop": "Winkel verwijderen",
      "shops.shopAdded": "Winkel succesvol toegevoegd!",
      "shops.shopUpdated": "Winkel succesvol bijgewerkt!",
      "shops.shopDeleted": "Winkel succesvol verwijderd!",
      "shops.confirmDelete": "Weet u zeker dat u deze winkel wilt verwijderen?",
      
      // Dashboard - Shops
      "dashboard.myShops": "Mijn Winkels",
      "dashboard.manageShops": "Winkels beheren",
      "dashboard.manageShopsDesc": "Uw verkooppunten",
    }
  },
  fr: {
    translation: {
      // Navigation
      "nav.home": "Accueil",
      "nav.horses": "Chevaux",
      "nav.map": "Carte Événements",
      "nav.auctions": "Enchères",
      "nav.certificates": "Certificats",
      "nav.sponsors": "Sponsors",
      "nav.subscription": "Abonnement",
      "nav.shops": "Boutiques",
      
      // Hero
      "hero.title": "Investissez dans l'Avenir Équestre",
      "hero.subtitle": "Plateforme IA pour investissements équestres en Italie et Suisse",
      "hero.cta": "Explorer les Chevaux",
      
      // Dashboard
      "dashboard.title": "Tableau de Bord",
      "dashboard.totalHorses": "Total Chevaux",
      "dashboard.avgRoi": "ROI Moyen",
      "dashboard.activeAuctions": "Enchères Actives",
      "dashboard.marketTrend": "Tendance Marché",
      "dashboard.myHorses": "Mes Chevaux",
      "dashboard.myAuctions": "Mes Enchères",
      "dashboard.myShops": "Mes Boutiques",
      "dashboard.activePlan": "Plan Actif",
      "dashboard.welcome": "Bienvenue",
      "dashboard.manageHorses": "Gérer Mes Chevaux",
      "dashboard.manageHorsesDesc": "Ajouter, modifier ou supprimer des chevaux",
      "dashboard.manageAuctions": "Gérer Mes Enchères",
      "dashboard.manageAuctionsDesc": "Créer de nouvelles enchères ou gérer les actives",
      "dashboard.manageShops": "Gérer Boutiques",
      "dashboard.manageShopsDesc": "Vos points de vente",
      "dashboard.recentHorses": "Mes Chevaux Récents",
      
      // Horses
      "horses.title": "Catalogue Chevaux",
      "horses.filter.region": "Région",
      "horses.filter.country": "Pays",
      "horses.filter.all": "Tous",
      "horses.filter.allRegions": "Toutes les Régions",
      "horses.age": "Âge",
      "horses.years": "ans",
      "horses.breed": "Race",
      "horses.price": "Prix",
      "horses.roi": "ROI Estimé",
      "horses.viewDetails": "Détails",
      "horses.analyzeRoi": "Analyse IA",
      "horses.pedigree": "Pedigree",
      "horses.performance": "Performance",
      "horses.competitions": "Compétitions",
      "horses.wins": "Victoires",
      "horses.places": "Places",
      "horses.ranking": "Classement FISE",
      "horses.anafi": "Statistiques ANAFI",
      "horses.fertility": "Indice Fertilité",
      "horses.geneticScore": "Score Génétique",
      "horses.addHorse": "Ajouter Chevaux",
      "horses.manualEntry": "Saisie Manuelle",
      "horses.uploadFile": "Télécharger CSV/JSON",
      "horses.csvFormat": "Format CSV: name, breed, age, region, country, price_eur, fise_id",
      "horses.notFound": "Cheval non trouvé",
      "horses.featured": "Chevaux en Vedette",
      "horses.viewAll": "Voir tout",
      "horses.regions": "Régions Couvertes",
      "horses.father": "Père",
      "horses.mother": "Mère",
      "horses.lineage": "Lignée",
      
      // Map
      "map.title": "Carte Événements FISE/FEI",
      "map.events": "Événements",
      "map.filter.type": "Type d'Événement",
      "map.all": "Tous",
      
      // Auctions
      "auctions.title": "Marketplace Enchères",
      "auctions.subtitle": "Focus: Verona Fiere",
      "auctions.currentBid": "Enchère Actuelle",
      "auctions.startPrice": "Prix de Départ",
      "auctions.commission": "Commission",
      "auctions.placeBid": "Enchérir",
      "auctions.endDate": "Date de Fin",
      "auctions.minIncrement": "Incrément Minimum",
      "auctions.yourName": "Votre nom",
      "auctions.bidderName": "Nom de l'enchérisseur",
      "auctions.active": "Active",
      "auctions.lastBids": "Dernières enchères",
      "auctions.bidError": "L'enchère doit être supérieure à",
      "auctions.enterName": "Entrez votre nom",
      
      // Certificates
      "certificates.title": "Certificats Sanitaires UE",
      "certificates.subtitle": "Certificats sanitaires UE avec vérification blockchain SHA-256",
      "certificates.blockchain": "Vérification Blockchain",
      "certificates.scanQr": "Scanner QR",
      "certificates.issueDate": "Date d'Émission",
      "certificates.expiryDate": "Date d'Expiration",
      "certificates.authority": "Autorité",
      "certificates.generate": "Générer Certificat",
      "certificates.verify": "Vérifier",
      "certificates.issued": "Certificats Émis",
      "certificates.valid": "Valide",
      "certificates.expired": "Expiré",
      "certificates.validCert": "Certificat Valide",
      "certificates.invalidCert": "Non Valide",
      "certificates.notFound": "Certificat non trouvé",
      "certificates.selectHorse": "Sélectionner cheval",
      "certificates.certType": "Type de Certificat",
      "certificates.horse": "Cheval",
      "certificates.hashPlaceholder": "Entrez hash ou premiers 12 caractères",
      "certificates.types.health": "Sanitaire UE",
      "certificates.types.export": "Export IT/CH",
      "certificates.types.competition": "Compétition FISE",
      
      // VAT
      "vat.title": "Calcul TVA IT/CH",
      "vat.from": "De",
      "vat.to": "À",
      "vat.amount": "Montant",
      "vat.calculate": "Calculer",
      "vat.result": "Résultat",
      "vat.importDuty": "Droits d'Import",
      "vat.total": "Total",
      "vat.vatRate": "Taux TVA",
      "vat.dutyAlert": "Attention: droits de douane applicables",
      
      // Sponsors
      "sponsors.title": "Sponsors Transfrontaliers",
      "sponsors.subtitle": "Matching sponsors IT/CH avec alertes droits d'import",
      "sponsors.match": "Associer Sponsor",
      "sponsors.matchScore": "Score de Compatibilité",
      "sponsors.crossBorder": "Transfrontalier",
      "sponsors.all": "Tous les Sponsors",
      "sponsors.findSponsor": "Trouver des Sponsors pour Vos Chevaux",
      "sponsors.myRequests": "Mes Demandes",
      "sponsors.selectHorse": "Sélectionner cheval pour association",
      "sponsors.loginRequired": "Connectez-vous pour trouver des sponsors",
      "sponsors.noHorses": "Vous n'avez pas encore de chevaux. Ajoutez-en un pour trouver des sponsors.",
      "sponsors.addHorse": "Ajouter Cheval",
      "sponsors.seekingSponsor": "Cherche sponsor",
      "sponsors.sendRequest": "Envoyer Demande",
      "sponsors.messagePlaceholder": "Message au sponsor (optionnel)",
      "sponsors.types.feed": "Alimentation",
      "sponsors.types.equipment": "Équipement",
      "sponsors.types.transport": "Transport",
      "sponsors.types.veterinary": "Vétérinaire",
      "sponsors.types.training": "Entraînement",
      
      // Subscription
      "subscription.title": "Plans d'Abonnement",
      "subscription.subtitle": "Choisissez le plan adapté à vos besoins",
      "subscription.free": "Gratuit",
      "subscription.premium": "Premium",
      "subscription.professional": "Professionnel",
      "subscription.monthly": "/mois",
      "subscription.features": "Fonctionnalités",
      "subscription.subscribe": "S'abonner",
      "subscription.current": "Plan Actuel",
      "subscription.recommended": "Recommandé",
      "subscription.features.catalog": "Accès catalogue chevaux",
      "subscription.features.basicMap": "Carte événements basique",
      "subscription.features.limitedAnalysis": "5 analyses ROI/mois",
      "subscription.features.emailNotif": "Notifications email",
      "subscription.features.allFree": "Tout Gratuit +",
      "subscription.features.unlimitedAI": "Analyses IA illimitées",
      "subscription.features.sponsorMatch": "Matching sponsors",
      "subscription.features.blockchain": "Certificats blockchain",
      "subscription.features.dutyAlert": "Alertes droits import",
      "subscription.features.prioritySupport": "Support prioritaire",
      "subscription.features.allPremium": "Tout Premium +",
      "subscription.features.apiAccess": "Accès API données",
      "subscription.features.whiteLabel": "Rapports marque blanche",
      "subscription.features.consulting": "Conseil dédié",
      "subscription.features.privateAuctions": "Gestion enchères privées",
      "subscription.features.accountManager": "Gestionnaire de compte",
      
      // Auth
      "auth.login": "Connexion",
      "auth.logout": "Déconnexion",
      "auth.register": "Inscription",
      "auth.email": "Email",
      "auth.password": "Mot de passe",
      "auth.confirmPassword": "Confirmer Mot de passe",
      "auth.loginTitle": "Connexion",
      "auth.loginSubtitle": "Connectez-vous à votre compte EquiInvest AI",
      "auth.registerTitle": "Inscription",
      "auth.registerSubtitle": "Créez votre compte pour vendre aux enchères",
      "auth.noAccount": "Pas de compte?",
      "auth.hasAccount": "Déjà un compte?",
      "auth.loggingIn": "Connexion en cours...",
      "auth.registering": "Inscription en cours...",
      "auth.createAccount": "Créer Compte",
      "auth.accountType": "Type de Compte",
      "auth.name": "Nom/Raison Sociale",
      "auth.companyName": "Nom Entreprise",
      "auth.phone": "Téléphone",
      "auth.country": "Pays",
      "auth.region": "Région",
      "auth.vatNumber": "Numéro TVA",
      "auth.types.scuderia": "Écurie",
      "auth.types.scuderiaDesc": "Gérer chevaux et enchères",
      "auth.types.rivenditore": "Revendeur",
      "auth.types.rivenditoreDesc": "Vendre des chevaux",
      "auth.types.sponsor": "Sponsor",
      "auth.types.sponsorDesc": "Sponsoriser des chevaux",
      "auth.types.privato": "Particulier",
      "auth.types.privatoDesc": "Acheter des chevaux",
      "auth.passwordMismatch": "Les mots de passe ne correspondent pas",
      "auth.passwordTooShort": "Le mot de passe doit contenir au moins 6 caractères",
      
      // Payment
      "payment.success": "Paiement Effectué!",
      "payment.successMessage": "Merci pour votre abonnement. Votre compte a été mis à jour.",
      "payment.processing": "Paiement en Cours",
      "payment.processingMessage": "Le paiement est en cours de traitement. Vous recevrez un email de confirmation.",
      "payment.backHome": "Retour à l'Accueil",
      "payment.backSubscription": "Retour aux Abonnements",
      "payment.verifying": "Vérification du paiement...",
      
      // Notifications
      "notifications.title": "Notifications",
      "notifications.none": "Aucune notification",
      "notifications.newMatch": "Nouveau Match",
      "notifications.newAuction": "Nouvelle Enchère",
      "notifications.bidUpdate": "Mise à jour Enchère",
      
      // Shops
      "shops.title": "Boutiques Équestres",
      "shops.all": "Toutes",
      "shops.italy": "Italie",
      "shops.switzerland": "Suisse",
      "shops.category": "Catégorie",
      "shops.categories.all": "Toutes",
      "shops.categories.selleria": "Sellerie",
      "shops.categories.mangimi": "Alimentation",
      "shops.categories.veterinario": "Vétérinaire",
      "shops.categories.maniscalco": "Maréchal-ferrant",
      "shops.categories.trasporto": "Transport",
      "shops.categories.abbigliamento": "Vêtements",
      "shops.categories.attrezzature": "Équipements",
      "shops.categories.altro": "Autre",
      "shops.addShop": "Ajouter Boutique",
      "shops.registerShop": "Enregistrer votre boutique",
      "shops.loginToAdd": "Connectez-vous pour ajouter",
      "shops.myShops": "Mes Boutiques",
      "shops.manageShops": "Gérer Boutiques",
      "shops.manageShopsDesc": "Vos points de vente",
      "shops.noShops": "Aucune Boutique",
      "shops.noShopsDesc": "Ajoutez votre première boutique pour l'afficher sur la carte",
      "shops.shopName": "Nom de la Boutique",
      "shops.description": "Description",
      "shops.address": "Adresse",
      "shops.city": "Ville",
      "shops.phone": "Téléphone",
      "shops.email": "Email",
      "shops.website": "Site Web",
      "shops.openingHours": "Heures d'Ouverture",
      "shops.latitude": "Latitude",
      "shops.longitude": "Longitude",
      "shops.editShop": "Modifier Boutique",
      "shops.deleteShop": "Supprimer Boutique",
      "shops.shopAdded": "Boutique ajoutée avec succès!",
      "shops.shopUpdated": "Boutique mise à jour avec succès!",
      "shops.shopDeleted": "Boutique supprimée avec succès!",
      "shops.confirmDelete": "Êtes-vous sûr de vouloir supprimer cette boutique?",
      
      // Common
      "common.loading": "Chargement...",
      "common.error": "Erreur",
      "common.success": "Succès",
      "common.save": "Enregistrer",
      "common.cancel": "Annuler",
      "common.delete": "Supprimer",
      "common.edit": "Modifier",
      "common.add": "Ajouter",
      "common.upload": "Télécharger",
      "common.download": "Télécharger",
      "common.italy": "Italie",
      "common.switzerland": "Suisse",
      "common.all": "Tous",
      "common.regions.ticino": "Tessin",
      "common.regions.lombardia": "Lombardie",
      "common.regions.toscana": "Toscane",
      "common.regions.piemonte": "Piémont",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'it', // Italian default
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
